import { Check, MapPin, Clock, Phone, Users, Heart, Star, Sparkles, Calendar, Shield } from 'lucide-react';

interface RichFAQAnswerProps {
  children: React.ReactNode;
}

/**
 * Wraps FAQ answer content with rich styling.
 * Supports plain text or structured JSX content.
 */
const RichFAQAnswer = ({ children }: RichFAQAnswerProps) => (
  <div className="text-sm text-muted-foreground leading-relaxed space-y-3">
    {children}
  </div>
);

/** Bullet list for FAQ answers */
export const FAQList = ({ items }: { items: string[] }) => (
  <ul className="space-y-2 mt-2">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-2.5">
        <Check size={14} className="text-primary mt-0.5 shrink-0" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

/** Highlighted stat/info badge */
export const FAQHighlight = ({ icon: Icon, label, value }: { icon: any; label: string; value: string }) => (
  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/5 border border-primary/10 text-xs font-medium">
    <Icon size={13} className="text-primary" />
    <span className="text-foreground font-heading">{value}</span>
    <span className="text-muted-foreground">{label}</span>
  </div>
);

/** Row of highlight badges */
export const FAQHighlights = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-wrap gap-2 mt-3">{children}</div>
);

/** Callout box */
export const FAQCallout = ({ children, variant = 'info' }: { children: React.ReactNode; variant?: 'info' | 'tip' }) => (
  <div className={`mt-3 p-3.5 rounded-xl border-l-3 text-xs leading-relaxed ${
    variant === 'tip' 
      ? 'border-primary bg-primary/5 text-foreground/80' 
      : 'border-accent bg-accent/5 text-foreground/80'
  }`}>
    {children}
  </div>
);

export { MapPin, Clock, Phone, Users, Heart, Star, Sparkles, Calendar, Shield };
export default RichFAQAnswer;
